import { render, staticRenderFns } from "./out-stock-tag-button.vue?vue&type=template&id=67c50e98&"
import script from "./out-stock-tag-button.vue?vue&type=script&lang=js&"
export * from "./out-stock-tag-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports